import { render, staticRenderFns } from "./identical_content.vue?vue&type=template&id=462fa22e&scoped=true&"
import script from "./identical_content.vue?vue&type=script&lang=js&"
export * from "./identical_content.vue?vue&type=script&lang=js&"
import style0 from "./identical_content.vue?vue&type=style&index=0&id=462fa22e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462fa22e",
  null
  
)

export default component.exports